const alerts = {
  moduleTitle: "التنبيهات",
  nav: {
    log: "سجل التنبيهات",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
  },
  priorities: {
    VERY_HIGH: "عالية جدًا",
    HIGH: "عالية",
    MEDIUM: "متوسطة",
    LOW: "منخفضة",
  },
  status: {
    ACTIVE: "نشط",
    INACTIVE: "غير نشط",
  },
  list: {
    title: "إدارة التنبيهات",
    subtitle:
      "عرض وتعديل وتكرار تنبيهات الأجهزة والمستشعرات والأصول في الوقت الفعلي.",
    toolbar: {
      search: "بحث",
      searchPlaceholder: "بحث...",
      add: "إضافة تنبيه",
    },
    filters: {
      filters: "التصفية",
      type: "نوع التنبيه",
      assignmentType: "نوع التعيين",
      priority: "الأولوية",
      status: "الحالة",
      all: "الكل",
    },
    table: {
      company: "اسم المؤسسة",
      name: "اسم التنبيه",
      type: "نوع التنبيه",
      priority: "الأولوية",
      assignmentType: "نوع التعيين",
      status: "الحالة",
      empty: "لا توجد تنبيهات.",
      error: "تعذر تحميل التنبيهات.",
      loading: "جارٍ تحميل التنبيهات",
      total: "إجمالي {{total}} التنبيهات",
      rowsPerPageLabel: "عدد الصفوف",
      nextPage: "الصفحة التالية",
      previousPage: "الصفحة السابقة",
      pagination: "عدد الصفوف",
      sortAscending: "ترتيب تصاعدي",
      sortDescending: "ترتيب تنازلي",
      actionMenu: "الإجراءات",
    },
    actions: {
      view: "عرض",
      update: "تعديل",
      delete: "حذف",
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا التنبيه؟",
      warning: "لا يمكن التراجع عن هذا الإجراء.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      success: "تم حذف التنبيه بنجاح.",
    },
  },
  detail: {
    subtitle: "إعدادات التنبيه وشروط التفعيل والمستلمين والجدول الزمني.",
    backToList: "العودة إلى التنبيهات",
    edit: "تعديل",
    loading: "جارٍ تحميل التنبيه",
    loadError: "تعذر تحميل التنبيه.",
    notAvailable: "-",
    sections: {
      general: "المعلومات العامة",
      trigger: "شروط التنبيه",
      assignment: "التعيين والتخصيص",
      schedule: "الجدول الزمني",
      recipients: "مستلم التنبيه",
    },
    fields: {
      company: "اسم المؤسسة",
      name: "اسم التنبيه",
      type: "نوع التنبيه",
      priority: "الأولوية",
      status: "الحالة",
      description: "ملاحظات",
      assignmentType: "نوع التعيين",
      assignmentValue: "قيمة التعيين",
      minTemperature: "أقل درجة حرارة",
      maxTemperature: "أعلى درجة حرارة",
      minHumidity: "أقل رطوبة",
      maxHumidity: "أعلى رطوبة",
      minWeight: "أقل وزن",
      maxWeight: "أعلى وزن",
      alertValue: "قيمة التنبيه",
      sensor: "الحساس",
      operator: "المعامل",
      value: "القيمة",
      unit: "الوحدة",
      alwaysActive: "نشط دائمًا",
      activeDays: "أيام التفعيل",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
    },
    binary: {
      on: "تشغيل",
      off: "إيقاف",
    },
    yes: "نعم",
    no: "لا",
    noRecipients: "لا يوجد مستلمون",
    moreRecipients: "{{count}} مستلمين آخرين",
  },
  targetTypes: {
    ASSET_TYPE: "نوع الأصل",
    ASSET: "أصول معينة",
    DEVICE_TYPE: "نوع الجهاز",
    DEVICE: "أجهزة معينة",
  },
  days: {
    SATURDAY: "السبت",
    SUNDAY: "الأحد",
    MONDAY: "الاثنين",
    TUESDAY: "الثلاثاء",
    WEDNESDAY: "الأربعاء",
    THURSDAY: "الخميس",
    FRIDAY: "الجمعة",
  },
  create: {
    title: "إضافة تنبيه",
    subtitle:
      "تكوين القواعد، الشروط الفنية، الأهداف والجدول الزمني لحزم التنبيهات.",
    back: "العودة إلى التنبيهات",
    save: "حفظ",
    cancel: "إلغاء",
    success: "تم إنشاء التنبيه بنجاح.",
    duplicateName: "اسم التنبيه موجود بالفعل.",
    optional: "(اختياري)",
    sections: {
      general: "المعلومات العامة",
      trigger: "شروط التنبيه",
      assignment: "التعيين والتخصيص",
      schedule: "الجدول الزمني للنشاط",
      notifications: "الإعدادات والإشعارات",
    },
    fields: {
      company: "اسم المؤسسة",
      companyPlaceholder: "اختر المؤسسة",
      name: "اسم التنبيه",
      nameArPlaceholder: "اسم التنبيه بالعربي",
      nameEnPlaceholder: "اسم التنبيه بالإنجليزي",
      category: "نوع التنبيه",
      categoryPlaceholder: "اختر نوع التنبيه",
      priority: "الأولوية",
      priorityPlaceholder: "اختر الأولوية",
      description: "وصف التنبيه",
      descriptionPlaceholder: "أدخل وصف التنبيه",
      maxSpeed: "الحد الأقصى للسرعة (كم/س)",
      downtimeMinutes: "وقت التوقف بالدقائق",
      minTemperature: "الحد الأدنى لدرجة الحرارة",
      maxTemperature: "الحد الأقصى لدرجة الحرارة",
      minHumidity: "الحد الأدنى للرطوبة",
      maxHumidity: "الحد الأقصى للرطوبة",
      minWeight: "الحد الأدنى للوزن",
      maxWeight: "الحد الأقصى للوزن",
      alertValue: "الحالة المتوقعة للمستشعر الرقمي",
      sensorType: "نوع الحساس",
      sensorTypePlaceholder: "اختر نوع الحساس",
      operator: "المعامل (Operator)",
      operatorPlaceholder: "اختر المعامل",
      thresholdValue: "القيمة (Threshold)",
      thresholdValueTo: "إلى القيمة",
      unit: "الوحدة (unit)",
      unitPlaceholder: "مثال: c",
      triggerHint: "اختر نوع التنبيه لعرض شروطه.",
      driverBehaviourHint:
        "يُرسل التنبيه كلما رصدت كاميرا مراقبة السائق هذا السلوك، ولا توجد شروط لتحديدها.",
      targetType: "نوع التعيين",
      targetTypePlaceholder: "اختر نوع التعيين",
      branch: "الفرع",
      branchPlaceholder: "اختر الفرع",
      geofence: "اسم المنطقة الجغرافية",
      geofencePlaceholder: "اختر المنطقة الجغرافية",
      geofenceClear: "إزالة المنطقة الجغرافية",
      targets: "تحديد العناصر المشمولة بالربط",
      targetsPlaceholder: {
        ASSET_TYPE: "الرجاء اختيار واحد أو أكثر من أنواع الأصول",
        ASSET: "الرجاء اختيار واحد أو أكثر من الأصول",
        DEVICE_TYPE: "الرجاء اختيار واحد أو أكثر من أنواع الأجهزة",
        DEVICE: "الرجاء اختيار واحد أو أكثر من الأجهزة",
      },
      allAssetTypes: "كل أنواع الأصول",
      targetsNoBranch: "اختر الفرع أولًا",
      targetsNoType: "اختر نوع التعيين أولًا",
      alwaysActive: "نشط دائمًا",
      activeDays: "الأيام النشطة",
      activeDaysPlaceholder: "يمكن اختيار يوم أو أكثر",
      repeatWeekly: "تكرار أسبوعيًا",
      startTime: "وقت البدء اليومي",
      endTime: "وقت الانتهاء اليومي",
      recipients: "مستلم التنبيه",
      recipientsPlaceholder: "اختر المستلمين",
      recipientsHint: "يمكن اختيار أكثر من مستلم",
      selectCompanyFirst: "اختر المؤسسة أولًا",
      search: "بحث…",
      empty: "لا توجد نتائج",
      loading: "جارٍ التحميل",
      remove: "إزالة {{name}}",
    },
    binary: {
      ON: "تشغيل (on)",
      OFF: "إيقاف (off)",
    },
    operators: {
      GREATER_THAN: "أكبر من >",
      GREATER_THAN_OR_EQUAL: "أكبر من أو يساوي ≥",
      LESS_THAN: "أقل من <",
      LESS_THAN_OR_EQUAL: "أقل من أو يساوي ≤",
      EQUAL: "يساوي =",
      BETWEEN: "بين",
    },
    validation: {
      required: "هذا الحقل مطلوب.",
      number: "أدخل رقمًا صحيحًا.",
      positive: "يجب أن تكون القيمة أكبر من صفر.",
      maxAboveMin: "يجب أن يكون الحد الأقصى أكبر من الحد الأدنى.",
      humidityPair: "أدخل الحد الأدنى والأقصى للرطوبة معًا أو اتركهما فارغين.",
      toAboveFrom: "يجب أن تكون القيمة الثانية أكبر من الأولى.",
      targetsRequired: "اختر عنصرًا واحدًا على الأقل.",
      daysRequired: "اختر يومًا واحدًا على الأقل.",
      endAfterStart: "يجب أن يكون وقت الانتهاء بعد وقت البدء.",
      recipientsRequired: "اختر مستلمًا واحدًا على الأقل.",
    },
    unsavedChanges: {
      title: "تغييرات غير محفوظة",
      message: "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
      stay: "البقاء",
      leave: "مغادرة",
      close: "إغلاق",
    },
  },
  edit: {
    title: "تعديل التنبيه",
    subtitle: "تحديث قواعد التنبيه وشروطه والعناصر المرتبطة وجدوله الزمني.",
    back: "العودة إلى التنبيه",
    success: "تم تحديث التنبيه بنجاح.",
    loading: "جارٍ تحميل التنبيه",
    loadError: "تعذر تحميل التنبيه. يرجى المحاولة مرة أخرى.",
    status: "نشط",
    activateQuestion: "هل أنت متأكد أنك تريد تفعيل هذا التنبيه؟",
    deactivateQuestion: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا التنبيه؟",
    activateTitle: "تفعيل التنبيه",
    deactivateTitle: "إلغاء تفعيل التنبيه",
    confirm: "تأكيد",
    cancel: "إلغاء",
    close: "إغلاق",
  },
  history: {
    title: "سجل التنبيهات",
    subtitle: "عرض والبحث في سجل التنبيهات التاريخية للمركبات",
    search: "البحث في سجل التنبيهات",
    searchPlaceholder: "بحث...",
    types: {
      SENSOR: "حساس",
      SPEED: "سرعة",
      DOWNTIME: "توقف",
    },
    table: {
      company: "المؤسسة",
      asset: "اسم الأصل",
      alertName: "اسم التنبيه",
      alertType: "نوع التنبيه",
      triggeredValue: "القيمة",
      occurredAt: "التاريخ والوقت",
      location: "الموقع",
      loading: "جارٍ تحميل سجل التنبيهات",
      total: "الإجمالي {{total}} تنبيه",
    },
    location: {
      unavailable: "الموقع غير متاح لهذا التنبيه.",
      openInMaps: "فتح {{coordinates}} في خرائط Google",
    },
    filters: {
      filters: "عوامل التصفية",
      company: "المؤسسة",
      allCompanies: "كل المؤسسات",
      companySearch: "ابحث عن مؤسسة",
      companyEmpty: "لا توجد مؤسسات.",
      asset: "المركبة",
      allAssets: "كل المركبات",
      assetSearch: "ابحث عن مركبة",
      assetEmpty: "لا توجد مركبات.",
      alertType: "نوع التنبيه",
      all: "الكل",
      alertName: "اسم التنبيه",
      alertNamePlaceholder: "اكتب اسم التنبيه",
      sensor: "الحساس",
      allSensors: "كل الحساسات",
      sensorSearch: "ابحث عن حساس",
      sensorEmpty: "لا توجد حساسات.",
      period: "الفترة",
      periodPlaceholder: "من تاريخ - إلى تاريخ",
      clearPeriod: "مسح الفترة",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
      reset: "إعادة تعيين",
      apply: "تطبيق",
    },
    empty: "لم يتم العثور على سجل تنبيهات",
    noMatch: "لا توجد تنبيهات تطابق معايير البحث المحددة.",
    errorTitle: "تعذر تحميل سجل التنبيهات.",
    errorBody: "حدث خطأ أثناء الاتصال بالخادم. حاول مرة أخرى",
    retry: "إعادة المحاولة",
    detail: {
      back: "العودة إلى سجل التنبيهات",
      loading: "جارٍ تحميل التنبيه",
      loadError: "تعذر تحميل التنبيه. حاول مرة أخرى.",
      notAvailable: "غير متاح",
      sections: {
        general: "تفاصيل",
        SPEED: "تفاصيل تجاوز السرعة",
        SENSOR: "تفاصيل تنبيه الحساس",
        DOWNTIME: "تفاصيل التوقف",
      },
      fields: {
        alertName: "اسم التنبيه",
        asset: "اسم الأصل",
        company: "اسم المؤسسة",
        location: "الموقع",
        occurredAt: "وقت حدوث التنبيه",
        alertType: "نوع التنبيه",
        recordedSpeed: "السرعة المرصودة",
        speedLimit: "السرعة المحددة للنطاق",
        sensor: "الحساس",
        sensorType: "نوع الحساس",
        triggeredValue: "القيمة المرصودة",
        unit: "وحدة القياس",
        condition: "الشرط المحدد",
        duration: "مدة التوقف",
      },
      speed: "{{value}} km/h",
      minutes: "{{count}} دقيقة",
      // The configured condition, under the operators the history sends.
      conditions: {
        GREATER_THAN: "أكبر من {{value}}",
        GREATER_THAN_OR_EQUAL: "أكبر من أو يساوي {{value}}",
        LESS_THAN: "أقل من {{value}}",
        LESS_THAN_OR_EQUAL: "أقل من أو يساوي {{value}}",
        EQUAL: "يساوي {{value}}",
        BETWEEN: "بين {{value}} و{{valueTo}}",
        OUTSIDE_RANGE: "خارج النطاق من {{value}} إلى {{valueTo}}",
        IS: "{{value}}",
      },
    },
  },
  permissions: {
    core: "النواة",
    alertManagement: "إدارة التنبيهات",
    alerts: "التنبيهات",
    log: "سجل التنبيهات",
  },
};

export default alerts;
